import { render, staticRenderFns } from "./PropertyAdditionalChargeDetails.vue?vue&type=template&id=51331b80&scoped=true&"
import script from "./PropertyAdditionalChargeDetails.vue?vue&type=script&lang=js&"
export * from "./PropertyAdditionalChargeDetails.vue?vue&type=script&lang=js&"
import style0 from "./PropertyAdditionalChargeDetails.vue?vue&type=style&index=0&id=51331b80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51331b80",
  null
  
)

export default component.exports